import React, { useMemo } from 'react';
import xss from 'xss';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { TRANSLATIONS } from '../__translations__';
import { getLocale } from '../../utils';
import * as S from './styles';
export const CountdownMessage = ({ countdown, open, onClose, anchorOrigin, refreshable, onRefresh, }) => {
    const message = useMemo(() => {
        var _a;
        const translation = (_a = TRANSLATIONS[getLocale()]) !== null && _a !== void 0 ? _a : TRANSLATIONS.en;
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { dangerouslySetInnerHTML: { __html: xss(TRANSLATIONS[getLocale()].countdown(countdown)) } }),
            refreshable && (React.createElement(S.Button, { "aria-label": "extend-session", variant: "text", onClick: onRefresh },
                React.createElement(AutorenewIcon, null),
                React.createElement(S.Typography, null, translation.extendSession)))));
    }, [countdown, onRefresh, refreshable]);
    const action = useMemo(() => (React.createElement(S.IconButton, { "aria-label": "close", color: "inherit", onClick: onClose },
        React.createElement(CloseIcon, null))), [onClose]);
    return (React.createElement(S.Snackbar, { open: open, onClose: onClose, anchorOrigin: anchorOrigin, message: message, action: action }));
};
//# sourceMappingURL=CountdownMessage.js.map